import styled from '@emotion/styled';

export const CardPaymentWrapper = styled.div`
  background-color: ${({ theme }) => theme.color[3]};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 600px;
  height: 532px;
  border-radius: 32px;
  padding: 40px;
`;

export const CardPaymentHeadingText = styled.div`
  ${({ theme }) => theme.typography.REGULAR_30};
  color: ${({ theme }) => theme.color[1]};
  text-align: center;
  line-height: 1.5;
  margin-bottom: 20px;
  white-space: pre-line;
`;

export const CardPaymentWarningText = styled.div`
  ${({ theme }) => theme.typography.REGULAR_12};
  color: ${({ theme }) => theme.color['warningRed']};
  text-align: center;
  margin-bottom: 20px;
  white-space: pre-line;
`;

export const CardPaymentText = styled.div`
  ${({ theme }) => theme.typography.REGULAR_16};
`;

export const CardImageContainer = styled.div`
  width: 320px;
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
